/* eslint no-multi-spaces: 0 */
/* eslint no-unused-vars : 0 */
/* eslint key-spacing    : 0 */

import { Eved, EventBus } from '@/event-bus'

export default {
  data() {
    return {
      nextLabel       : 'Next',
      nextEndpoint    : '',
      lastStep        : false,
      attachedFile    : null,
      uploadFileError : ''
    }
  },

  mounted() {
    this.$refs.steps.reset()
    // this.enterStep()
  },

  methods: {
    /**
     * onEnterStep
     */
    enterStep(payload) {
      const vm   = this
      const from = payload && payload.from
      const to   = payload && payload.to
      const fromEndpoint = from &&
                           from.$el.querySelector('form') &&
                           from.$el.querySelector('form').getAttribute('endpoint')
      const toEndpoint   = to &&
                           to.$attrs.endpoint

      let requestPayload = {
        filePath: this.$refs.steps.$el.getAttribute('file-id'),
        userId: vm.$user.$.user.UserID,
        vendorId: vm.$user.$.data.VendorID,
        vci: vm.$user.$.user.VCI,
        map: from ? JSON.stringify(from.$attrs.payload) : undefined
      }

      if (toEndpoint && from.section !== to.section) {
        this.api.post(toEndpoint, requestPayload).then(r => {
          if (r && r.data && to.$attrs.data && vm[to.$attrs.data]) {
            vm[to.$attrs.data] = r.data

            // reset errors
            this.errors = null

            // set pendingData to prevent leaving the wizard
            vm.$store.state.pendingData = true
          }
        })
      }

      this._afterEnterStep()

      if (to || payload === null) {
        let stepSlug = to && ~to.href.indexOf('/d/') &&
                        to.href.split('/d/')[1]
                          .replace(/(\/|-)/g, ' ')
                          .replace('#', ' > ')
        payload && EventBus.$emit(Eved.GENERIC.WIZARD.ENTERED_STEP, stepSlug)
      }

      // onEnterStep callback
      if (to && to.$attrs.callback && typeof vm[to.$attrs.callback] === 'function') {
        vm[to.$attrs.callback]()
      }

      // endpoint feedback
      if (from && payload && payload.response && from.$attrs.feedback && typeof vm[from.$attrs.feedback] !== 'undefined') {
        vm[from.$attrs.feedback] = payload.response.data || null
      }
    },

    /**
     * afterEnterStep
     */
    _afterEnterStep() {
      const step = this.$refs.steps.getActiveTab()

      this.$nextTick(() => {
        const currentStep = this.$refs.steps.getActiveTab()

        // update next label
        this.nextLabel = currentStep &&
                         (
                          currentStep.$attrs['button-label'] ||
                          currentStep.$attrs['optional']
                         ) || 'Next'

        // check if last step
        this.lastStep = this.nextLabel === 'Ok'

        if (this.lastStep) {
          // EventBus.$emit(Eved.GENERIC.WIZARD.SUCCESS)
        }
      })

      if (typeof this.afterEnterStep === 'function') this.afterEnterStep()
    },

    /**
     * onExitStep
     */
    proceed() {
      const steps      = this.$refs.steps
      const activeStep = steps.getActiveTab()
      const form       = activeStep && activeStep.$el.querySelector('form')

      let valid = true

      this.nextEndpoint = form ? form.getAttribute('endpoint') : ''
      // check if file selected
      this.attachedFile = this.attachedFile || []

      if (activeStep) {
        // if step is optional (ie. error review)
        // skip to first step
        if (activeStep.optional) {
          // reset errors
          this.errors = null
          steps.reset()

          EventBus.$emit(Eved.GENERIC.WIZARD.RESET, activeStep.optional)
        }

        // mark invalid step
        if (form) {
          form.className = form.checkValidity() ? '' : 'invalid'
        }
      }

      if (activeStep.$attrs.validate && typeof this[activeStep.$attrs.validate] === 'function') {
        valid = this[activeStep.$attrs.validate]()
      }

      // proceed to next step
      valid && form && form.checkValidity() && steps.goToNextTab(this.uploadFileValid)
    }
  },

  computed: {
    // File upload error message handler
    uploadFileValid() {
      let message = ''// 'Nothing selected'

      if (this.attachedFile && this.attachedFile[0]) {
        const file = this.attachedFile[0]
        const error = file.error

        if (file.success === true && file.response) {
          this.$refs.steps.$el.setAttribute('file-id', file.response)
        }

        switch (error) {
          case 'extension':
            message = 'Wrong format'
            break
          case 'denied':
            message = 'Server could not be reached'
            break
        }

        if (!file.error && file.success) {
          EventBus.$emit(Eved.GENERIC.WIZARD.UPLOADED_FILE, this.$refs.header.title)
        }

        this.uploadFileError = message
        return !file.error
      }

      this.uploadFileError = message
      return false || this.attachedFile === null
    }
  }
}



// WEBPACK FOOTER //
// ./src/core/components/edTabNav/wizardMixin.js